/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ station: NonNullable<unknown> }} Consumption_Weather_Station_InfoInputs */



/**
* | output |
* | --- |
* | "Weather station: {station}" |
*
* @param {Consumption_Weather_Station_InfoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_weather_station_info = /** @type {((inputs: Consumption_Weather_Station_InfoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Weather_Station_InfoInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Weather station: ${i?.station}`)
	return /** @type {LocalizedString} */ (`Station météo : ${i?.station}`)
});